import React, { useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
import { Link, useNavigate } from "react-router-dom";
import { Button } from 'reactstrap';
import { FiLogOut } from "react-icons/fi";
import { useSelector } from "react-redux";
import "./profile.css";
import logo from "./../assets/widgets/logo.png";

// Fallback widget data when modules not loaded; matches sidebar main categories.
const DEFAULT_WIDGET_DATA = [
  { label: "Time & Attendance", link: "/timeTracker", img: require("./../assets/widgets/attendence.png"), alt: "Time & Attendance" },
  { label: "Leave Management", link: "/leaveManagement", img: require("./../assets/widgets/hire.png"), alt: "Leave Management" },
  { label: "Account", link: "/profile", img: require("./../assets/widgets/homecare.png"), alt: "Account" },
  { label: "Reports", link: "/shiftTime", img: require("./../assets/widgets/finance.png"), alt: "Reports" },
  { label: "Notifications", link: "/notifications", img: require("./../assets/widgets/Employee.png"), alt: "Notifications" },
];

// Map category title to widget image (for assigned-modules view).
const CATEGORY_IMAGES = {
  "Time & Attendance": { img: require("./../assets/widgets/attendence.png"), alt: "Time & Attendance" },
  "Leave Management": { img: require("./../assets/widgets/hire.png"), alt: "Leave Management" },
  "Account": { img: require("./../assets/widgets/homecare.png"), alt: "Account" },
  "Reports": { img: require("./../assets/widgets/finance.png"), alt: "Reports" },
  "Notifications": { img: require("./../assets/widgets/Employee.png"), alt: "Notifications" },
  "Dashboard": { img: require("./../assets/widgets/attendence.png"), alt: "Dashboard" },
};

const ProductWidget = () => {
  const navigate = useNavigate();
  const { allowedModules, loaded } = useSelector((state) => state.employeeModules);

  const widgetData = useMemo(() => {
    if (loaded && Array.isArray(allowedModules) && allowedModules.length > 0) {
      const nonDashboard = allowedModules.filter((m) => m.title !== "Dashboard");
      return nonDashboard.map((m) => {
        const firstPath = m.routes?.[0]?.path || "#";
        const asset = CATEGORY_IMAGES[m.title] || { img: DEFAULT_WIDGET_DATA[0].img, alt: m.title };
        return { label: m.title, link: firstPath, img: asset.img, alt: asset.alt };
      });
    }
    return DEFAULT_WIDGET_DATA;
  }, [loaded, allowedModules]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="product-widget-outer" style={{ position: 'relative' }}>
      <img src={logo} width="150px" style={{ position: 'absolute', left: '21px', top: '-32px' }} alt="Logo" />
      <Button
        color="danger"
        outline
        className="position-absolute top-0 end-0 m-3 d-flex align-items-center"
        onClick={handleLogout}
        style={{ zIndex: 10 }}
      >
        <FiLogOut className="me-2" style={{ fontSize: '1.25rem' }} />
        Logout
      </Button>

      <div className="container">
        <div className="product-widget mx-auto">
          <ul className="list-unstyled text-center">
            {widgetData.map((item, index) => (
              <li key={index}>
                <Link to={item.link}>
                  <span className="wgt-icon d-flex">
                    <img src={item.img} alt={item.alt} className="m-auto align-mddile" />
                  </span>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProductWidget;